export default __webpack_public_path__ + "static/maarten_regions_split-0193472cea5adbf52b18024f0e6571c3.jpg";